import { SetupDialogProvider, type SetupNotification } from "@tellescope/onboarding";
import { useAuth } from "@tellescope/tanstack-query";
import { ReactNode, useCallback } from "react";
import { toast } from "sonner";

export interface WebappSetupDialogProviderProps {
  children: ReactNode;
}

export const WebappSetupDialogProvider = ({ children }: WebappSetupDialogProviderProps) => {
  const { selectedOrganization, isLoadingOrganizations } = useAuth();

  const handleSuccess = useCallback(({ title, description }: SetupNotification) => {
    toast.success(title, { description });
  }, []);

  const handleError = useCallback(({ title, description }: SetupNotification) => {
    toast.warning(title, { description });
  }, []);

  // Wait for the organizations query to settle before mounting the dialog — until
  // then onboardingStatus is unloaded and the dialog would flash before hiding for
  // orgs that have already completed or skipped setup.
  if (selectedOrganization?.id && !isLoadingOrganizations) {
    return (
      <SetupDialogProvider selectedOrganization={selectedOrganization} onSuccess={handleSuccess} onError={handleError}>
        {children}
      </SetupDialogProvider>
    );
  }

  return <>{children}</>;
};
